import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as callRoutes } from './calls/routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import OnboardingInboxSetup from './onboarding/InboxSetup.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        {
          path: frontendURL('accounts/:accountId/workflows'),
          name: 'chat_flows',
          meta: { permissions: ['administrator'] },
          component: () => import('dashboard/workflows/WorkflowPage.vue'),
        },
        { path: frontendURL('accounts/:accountId/automation-tools/api'), name: 'chat_tools_api', meta: { permissions: ['administrator'], automationSection: 'api' }, component: () => import('dashboard/workflows/AutomationPage.vue') },
        { path: frontendURL('accounts/:accountId/automation-tools/ai'), name: 'chat_tools_ai', meta: { permissions: ['administrator'], automationSection: 'ai' }, component: () => import('dashboard/workflows/AutomationPage.vue') },
        { path: frontendURL('accounts/:accountId/automation-tools/broadcasts'), name: 'chat_tools_broadcasts', meta: { permissions: ['administrator'], automationSection: 'broadcasts' }, component: () => import('dashboard/workflows/AutomationPage.vue') },
        { path: frontendURL('accounts/:accountId/automation-tools/contacts'), name: 'chat_tools_contacts', meta: { permissions: ['administrator'], automationSection: 'contacts' }, component: () => import('dashboard/workflows/AutomationPage.vue') },
        { path: frontendURL('accounts/:accountId/automation-tools/audit'), name: 'chat_tools_audit', meta: { permissions: ['administrator'], automationSection: 'audit' }, component: () => import('dashboard/workflows/AutomationPage.vue') },
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...callRoutes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/onboarding/inbox-setup'),
      name: 'onboarding_inbox_setup',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingInboxSetup,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
